"use client";

import { useState, useEffect } from "react";
import { userService } from "@/services/user.service";

export function useIsLoggedIn() {
	const [loggedIn, setLoggedIn] = useState(false);

	useEffect(() => {
		const check = () => setLoggedIn(!!userService.userValue?.token);

		check();
		const sub = userService.user.subscribe(check);
		return () => sub.unsubscribe();
	}, []);

	return loggedIn;
}
